import React, { useEffect, useState, useCallback } from "react";
import { api } from "../api";
import { useApp } from "../context/AppContext";
import { IssueCard } from "../components/Artifacts";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useArtifactTranslations } from "../hooks/useArtifactTranslations";

export default function IssuesPage() {
  const { user, t, lang } = useApp();
  const [issues, setIssues] = useState([]);
  const [statusFilter, setStatusFilter] = useState("open");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const res = await api.get(`/issues?user_id=${user.id}`);
    setIssues(res.data);
    setLoading(false);
  }, [user.id]);

  useEffect(() => { load(); }, [load]);

  // Titles/descriptions in the viewer's language (lazy, cached)
  useArtifactTranslations(issues, setIssues, "issue", lang);

  const filtered = statusFilter === "all" ? issues : issues.filter((i) => i.status === statusFilter);

  return (
    <div className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 py-6">
      <h1 className="font-display font-bold text-2xl tracking-tight mb-4">{t("issues")}</h1>
      <Tabs value={statusFilter} onValueChange={setStatusFilter} className="mb-4">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="all" data-testid="issues-filter-all">{t("all")}</TabsTrigger>
          <TabsTrigger value="open" data-testid="issues-filter-open">{t("status_open")}</TabsTrigger>
          <TabsTrigger value="reviewing" data-testid="issues-filter-reviewing">{t("status_reviewing")}</TabsTrigger>
          <TabsTrigger value="action_required" data-testid="issues-filter-action">{t("status_action_required")}</TabsTrigger>
          <TabsTrigger value="resolved" data-testid="issues-filter-resolved">{t("status_resolved")}</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="space-y-3" data-testid="issues-board">
        {loading && [1, 2].map((i) => <div key={i} className="h-32 bg-muted rounded-xl animate-pulse" />)}
        {!loading && filtered.length === 0 && <div className="text-center text-sm text-muted-foreground py-12">{t("no_issues")}</div>}
        {!loading && filtered.map((issue) => (
          <IssueCard key={issue.id} issue={issue} showJob onChanged={load} />
        ))}
      </div>
    </div>
  );
}
